module.exports = __webpack_public_path__ + "img/LOGO.6e8d6c59.svg";